import React from 'react';
import { OAuthProviderType } from 'nekst-api';

interface SettingsProcessingStatusProps {
  provider?: OAuthProviderType | null;
}

export default function SettingsProcessingStatus({ provider }: SettingsProcessingStatusProps) {
  const getProviderName = () => {
    switch (provider) {
      case OAuthProviderType.GOOGLE:
        return 'Google';
      case OAuthProviderType.APPLE:
        return 'Apple';
      default:
        return 'OAuth';
    }
  };

  return (
    <div>
      <i
        className="fa fa-spinner fa-spin"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#007bff' }}
      />
      <h2 style={{ marginBottom: '1rem' }}>Connecting your {getProviderName()} account...</h2>
      <p style={{ color: '#666' }}>
        We're securely linking your {getProviderName()} account to your profile. This should only take a moment.
      </p>
    </div>
  );
}